import React from 'react';
import { Box, Typography } from '@material-ui/core';

const RoleList: React.FC = () => {
  return (
    <Box p={3}>
      <Typography variant="h4">Role List</Typography>
      <Typography variant="body1">Role List component - To be implemented</Typography>
    </Box>
  );
};

export default RoleList; 